import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from 'react-i18next'
import TableControl from 'pages/parts/TableControl'
import { formatMoney, formatDate } from 'helpers/helpers'
import { useLocation } from "react-router-dom"

function Index() {
	const { t } = useTranslation()
	const reduxSettings = useSelector(state => state.settings)

	const location = useLocation();
	const cashier = location.state?.cashier;
	const filterData = location.state?.filterData;
	const [modalTableControl, setModalTableControl] = useState(false)

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					<h4 className="text-start my-2">{t('CASHIER')}: {Object.values(cashier)?.[0]?.[0].cashierName}</h4>
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							
						</div>
					</div>

					<div className="filter-block">
						<div className="filter">
							<br />
							{(filterData.startDate || filterData.endDate) &&
								<span className="me-2">
									<b>{t('PERIOD')}: </b>
									{filterData.startDate &&
										<span>{formatDate(filterData.startDate)}</span>
									}
									{(filterData.startDate && filterData.endDate) &&
										<span>|</span>
									}
									{filterData.endDate &&
										<span>{formatDate(filterData.endDate)}</span>
									}
								</span>
							}
						</div>
					</div>
					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="text-end">{t('DATE')}</th>
									<th className="text-end">{t('SALE')}</th>
									<th className="text-end">{t('PAID')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.change) &&
										<th className="text-end">{t('CHANGE')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.discount) &&
										<th className="text-end">{t('DISCOUNT')}</th>
									}
									<th className="text-end">{t('ON_CREDIT')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.debtIn) &&
										<th className="text-end">{t('DEBT_RETURNED')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.expenseAmount) &&
										<th className="text-end">{t('OUT_BALANCE')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.returnedAmount) &&
										<th className="text-end">{t('RETURN')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetBonus) &&
										<th className="text-end">uGet {t('BONUS')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetPaid) &&
										<th className="text-end">uGet {t('PAYMENT_2')}</th>
									}
									<th className="text-end">{t('CASH')}</th>
									<th className="text-end">{t('TERMINAL')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.click) &&
										<th className="text-end">CLICK</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.payme) &&
										<th className="th-sortable text-end">PAYME</th>
									}
									<th className="th-sortable text-end">
										<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
									</th>
								</tr>
							</thead>
							<tbody>
								{Object.entries(cashier).map(([date, items]) =>
									items.map((item, idx) => (
										<tr key={idx}>
											<td className="text-end text-nowrap">{date}</td>
											<td className="text-end text-nowrap">{formatMoney(item.totalAmount)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.paid)}</td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.change) &&
												<td className="text-end text-nowrap">{formatMoney(item.change)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.discount) &&
												<td className="text-end text-nowrap">{formatMoney(item.discount)}</td>
											}
											<td className="text-end text-nowrap">{formatMoney(item.debtOut)}</td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.debtIn) &&
												<td className="text-end text-nowrap">{formatMoney(item.debtIn)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.expenseAmount) &&
												<td className="text-end text-nowrap">{formatMoney(item.expenseAmount)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.returnedAmount) &&
												<td className="text-end text-nowrap">{formatMoney(item.returnedAmount)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetBonus) &&
												<td className="text-end text-nowrap">{formatMoney(item.ugetBonus)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetPaid) &&
												<td className="text-end text-nowrap">{formatMoney(item.ugetPaid)}</td>
											}
											<td className="text-end text-nowrap">{formatMoney(item.cash)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.card)}</td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.click) &&
												<td className="text-end text-nowrap">{formatMoney(item.click)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.payme) &&
												<td className="text-end text-nowrap">{formatMoney(item.payme)}</td>
											}
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableReport'}>
			</TableControl>
			{/* MODAL TABLE CONTROL */}
		</>
	)
}

export default Index
